import type { TeamColor } from '@/api/teamGroups'

export interface TeamColorChoice {
  value: TeamColor
  labelKey: string
  hex: string
  /** Classes Tailwind pour fond doux + texte (mode clair). */
  softBg: string
  softText: string
  /** Classes Tailwind pour fond doux + texte (mode sombre). */
  darkBg: string
  darkText: string
}

/** Palette fixe alignée sur le backend `Team.COLOR_CHOICES`. */
export const TEAM_COLORS: TeamColorChoice[] = [
  {
    value: 'blue',
    labelKey: 'blue',
    hex: '#3B82F6',
    softBg: 'bg-blue-50',
    softText: 'text-blue-600',
    darkBg: 'dark:bg-blue-500/10',
    darkText: 'dark:text-blue-300',
  },
  {
    value: 'indigo',
    labelKey: 'indigo',
    hex: '#6366F1',
    softBg: 'bg-indigo-50',
    softText: 'text-indigo-600',
    darkBg: 'dark:bg-indigo-500/10',
    darkText: 'dark:text-indigo-300',
  },
  {
    value: 'green',
    labelKey: 'green',
    hex: '#22C55E',
    softBg: 'bg-green-50',
    softText: 'text-green-600',
    darkBg: 'dark:bg-green-500/10',
    darkText: 'dark:text-green-300',
  },
  {
    value: 'amber',
    labelKey: 'amber',
    hex: '#F59E0B',
    softBg: 'bg-amber-50',
    softText: 'text-amber-600',
    darkBg: 'dark:bg-amber-500/10',
    darkText: 'dark:text-amber-300',
  },
  {
    value: 'red',
    labelKey: 'red',
    hex: '#EF4444',
    softBg: 'bg-red-50',
    softText: 'text-red-600',
    darkBg: 'dark:bg-red-500/10',
    darkText: 'dark:text-red-300',
  },
  {
    value: 'purple',
    labelKey: 'purple',
    hex: '#A855F7',
    softBg: 'bg-purple-50',
    softText: 'text-purple-600',
    darkBg: 'dark:bg-purple-500/10',
    darkText: 'dark:text-purple-300',
  },
  {
    value: 'cyan',
    labelKey: 'cyan',
    hex: '#06B6D4',
    softBg: 'bg-cyan-50',
    softText: 'text-cyan-600',
    darkBg: 'dark:bg-cyan-500/10',
    darkText: 'dark:text-cyan-300',
  },
  {
    value: 'emerald',
    labelKey: 'emerald',
    hex: '#10B981',
    softBg: 'bg-emerald-50',
    softText: 'text-emerald-600',
    darkBg: 'dark:bg-emerald-500/10',
    darkText: 'dark:text-emerald-300',
  },
]

const COLOR_MAP = new Map<TeamColor, TeamColorChoice>(
  TEAM_COLORS.map((c) => [c.value, c]),
)

export function getTeamColor(color: TeamColor): TeamColorChoice {
  return COLOR_MAP.get(color) ?? TEAM_COLORS[0]
}
